import { ExceptionType } from '@views/Tickets/ticket.types';

export const exceptionTypeMap: Record<string, string> = {
  [ExceptionType.SLA_EXTENSION]: 'SLA Extension',
  [ExceptionType.RISK_ACCEPTED]: 'Risk Accepted',
};
